import api from './serviceApi'; // Import the axios instance

const loggerApi = {
    /**
     * Fetch a specific logger entry by its ID.
     * @param {number} id - The ID of the logger entry.
     * @returns {Promise<Object>} - The logger entry data.
     */
    getLoggerById: async (id) => {
        try {
            const response = await api.get(`/logger/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching logger by ID:', error);
            throw error;
        }
    },

    /**
     * Fetch a paginated list of logger entries with optional filters.
     * @param {Object} params - Query parameters such as `page`, `quantity`, `term`, `orderBy`, `include`.
     * @returns {Promise<Object>} - The paginated list of logger entries.
     */
    getLoggerPaginated: async (params) => {
        try {
            const response = await api.get('/logger/pagged', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching paginated logger entries:', error);
            throw error;
        }
    },

    /**
     * Fetch logger entries with filters such as date range, filters, and pagination.
     * @param {Object} params - Query parameters including `dateBegin`, `dateFinal`, `filtro`, `page`, `quantity`, `orderby`, `include`.
     * @returns {Promise<Object>} - The filtered list of logger entries.
     */
    getLogger: async (params) => {
        try {
            const response = await api.get('/logger', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching logger entries:', error);
            throw error;
        }
    },

    /**
     * Export customers based on filters.
     * @param {Object} params - Query parameters such as `term`, `isActive`, etc.
     * @returns {Promise<Blob>} - The exported file data.
     */
    exportLogs: async (params) => {
        try {
            const response = await api.get('/logger/export', {
                params
            });
            return response.data;
        } catch (error) {
            console.error('Error exporting customers:', error);
            throw error;
        }
    },
};

export default loggerApi;
